import { render, staticRenderFns } from "./FmlTextAreaEditor.vue?vue&type=template&id=4a070aea&"
import script from "./FmlTextAreaEditor.vue?vue&type=script&lang=js&"
export * from "./FmlTextAreaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports